interface NavigationProps {
  isScrolled: boolean;
}

export default function Navigation({ isScrolled }: NavigationProps) {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openContactForm = () => {
    const element = document.getElementById('contact-form');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-20 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img
              src="https://public.readdy.ai/ai/img_res/f767b215-268b-44c2-a2df-599c32304509.png"
              alt="株式会社おひさま ロゴ"
              className="w-10 h-10 object-contain"
            />
            <span
              className={`text-xl font-medium transition-colors ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
              style={{ fontFamily: "'Noto Serif JP', serif" }}
            >
              株式会社おひさま
            </span>
          </div>

          {/* Center Navigation */}
          <div className="flex items-center gap-12">
            <button
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#FF8B6A]' : 'text-white hover:text-[#FF8B6A]'
              }`}
            >
              ホーム
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#FF8B6A]' : 'text-white hover:text-[#FF8B6A]'
              }`}
            >
              会社概要
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
                isScrolled ? 'text-gray-700 hover:text-[#FF8B6A]' : 'text-white hover:text-[#FF8B6A]'
              }`}
            >
              事業内容
            </button>
          </div>

          {/* Contact Button */}
          <button
            onClick={openContactForm}
            className={`px-6 py-2 rounded-full border-2 text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
              isScrolled
                ? 'border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white'
                : 'border-white text-white hover:bg-white hover:text-gray-900'
            }`}
          >
            お問い合わせ
          </button>
        </div>
      </div>
    </nav>
  );
}